import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Set_New_Password_Modal.css";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../../../../../features/auth/authSlice";
import { Navigate, useNavigate } from "react-router-dom";
import Success_Modal from "../../success_modal/Success_Modal";
import Black_Btn from "../../../common_btn/Black_Btn/Black_Btn";

const Set_New_Password_Modal = ({
  email,
  contact,
  setEmail,
  setContact,
  ...props
}) => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm();

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const onSubmit = async (d) => {
    const data = {
      email: email,
      contact_no: contact,
      password: d?.password,
    };
    const verify = await dispatch(forgotPassword(data));

    if (verify.meta?.requestStatus === "fulfilled") {
      props?.onHide();
      // reset()
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        navigate("/");
      }, 3000);
    } else if (verify.meta?.requestStatus === "rejected") {
      setError("password", {
        type: "custom",
        message:
          verify.payload?.message ||
          "New password cannot be same as old password",
      });
    }
  };

  const handleClose = () => {
    reset(); // react-hook-form reset

    setPassword("");
    setPasswordAgain("");

    setShowPassword(false);
    setShowPasswordOne(false);

    setIconOne(faEyeSlash);
    setIconTwo(faEyeSlash);

    setEmail("");
    setContact("");

    props?.onHide();
  };

  useEffect(() => {
    if (!props.show) {
      reset();

      setPassword("");
      setPasswordAgain("");

      setShowPassword(false);
      setShowPasswordOne(false);

      setIconOne(faEyeSlash);
      setIconTwo(faEyeSlash);
    }
  }, [props.show]);

  return (
    <>
      <Modal
        className="Set_New_Password_Modal Reset_Password_Modal Login_Modal"
        size="md"
        {...props}
        centered
      >
        <Modal.Header>
          <div className="logo_holder">
            <img src="/assets/images/logo/logo.png" className="logo_img" />
          </div>
          <div className="close_img_div">
            <img
              src="/assets/images/icons/close_white.png"
              className="close_img"
              onClick={handleClose}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="reset_pass_main_form">
            <div className="close_img_div">
              <div className="title_div">
                <p className="title">Set New Password</p>
                <p className="sub_text">
                  Secure your account with a new password
                </p>
              </div>
            </div>

            <div className="reset_pass_div login_div">
              <div className="login_form_div">
                <Form>
                  <Form.Group className="gray_input_group input_group">
                    <Form.Label className="label_text">
                      Enter new Password
                    </Form.Label>
                    <div className="password_holder">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Enter password"
                        {...register("password", {
                          required: "Password is required",
                          minLength: {
                            value: 8,
                            message:
                              "Password must be at least 8 characters long",
                          },
                          pattern: {
                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                            message:
                              "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                          },
                        })}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {errors?.password && (
                        <sup className="text-danger">
                          {errors?.password?.message}
                        </sup>
                      )}
                      <div className="eye-icc">
                        <FontAwesomeIcon
                          icon={iconOne}
                          className="icon"
                          onClick={() => togglePasswordVisibility("password")}
                        />
                      </div>
                    </div>
                  </Form.Group>

                  <Form.Group className="gray_input_group input_group">
                    <Form.Label className="label_text">
                      Confirm New Password
                    </Form.Label>
                    <div className="password_holder">
                      <Form.Control
                        type={showPasswordOne ? "text" : "password"}
                        name="re_password"
                        placeholder="Confirm Password"
                        {...register("re_password", {
                          required: "Re-Enter Password  is required",
                          validate: (value) =>
                            value === password || "Passwords do not match",
                        })}
                        onChange={(e) => setPasswordAgain(e.target.value)}
                      />

                      <div className="eye-icc">
                        <FontAwesomeIcon
                          icon={iconTwo}
                          className="icon"
                          onClick={() =>
                            togglePasswordVisibility("reenterPassword")
                          }
                        />
                      </div>
                      {errors?.re_password && (
                        <sup className="text-danger">
                          {errors?.re_password?.message}
                        </sup>
                      )}
                    </div>
                  </Form.Group>

                  {password && (
                    <div className="password_check_list">
                      <PasswordChecklist
                        rules={[
                          "minLength",
                          "specialChar",
                          "number",
                          "capital",
                          "match",
                        ]}
                        minLength={8}
                        value={password}
                        valueAgain={passwordAgain}
                        onChange={(isValid) => {}}
                        style={{
                          fontSize: "10px",
                          padding: "4px",
                          margin: "0",
                        }}
                      />
                    </div>
                  )}
                </Form>
              </div>

              <div className="btns_holder set_new_password">
                <Black_Btn
                  btnText={"Reset Password"}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          handleClose();
          setShowSucsessModal(false);
        }}
        successText="Password Reset Successfully!"
      />
    </>
  );
};

export default Set_New_Password_Modal;
